import React, { Component } from 'react';
import { Configurations } from '../../Utils/Configurations';
import ReactTable from 'react-table';
import Geral from '../../Utils/Geral';

class TableOrder extends Component {

    constructor(props) {
        super(props);

        this.Configurations = new Configurations();
        this.Geral = new Geral();

        this.productBadgeType = this.productBadgeType.bind(this);

        this.state = {
            pedido: this.props.pedido,
            // pages: this.props.pages,
            loading: this.props.loading,
            // rowSelected: -1
        }

        this.columns = [
            {
                Header: 'Assinante',
                accessor: 'nomeMembro',
                className: 'text-left pointer',
                width: 150
            },
            {
                Header: 'Prod.',
                className: 'text-center pointer',
                width: 60,
                Cell: row => {
                    const sigla = row.original.sigla || row.original.siglaProduto;
                    return <span className={`badge badge-${Geral.badgeProductType(sigla.toLowerCase())} mx-1`}>{sigla}</span>
                }
            },
            {
                Header: 'Qtde',
                accessor: 'qtde',
                className: 'text-center pointer',
                width: 100,
                Cell: row => {
                    return (this.props.verificaProdutoDigitalSelecionado(row.original.idProduto)) ? (
                        <span>{row.value}</span>
                    ) : (
                        <div className="d-flex align-items-center justify-content-center">
                            <i className="fa fa-plus mx-3" onClick={() => this.props.aumentaQtde(row.index)}></i>
                            <span>{row.value}</span>
                            <i className="fa fa-minus mx-3" onClick={() => this.props.diminueQtde(row.index)}></i>
                        </div>
                    )
                }

            },
            {
                Header: 'Plano',
                accessor: 'familiar',
                className: 'text-center pointer',
                width: 60,
                Cell: row => <span>{row.value ? 'fam.' : 'indiv.'}</span>

            },
            {
                Header: 'Período',
                className: 'pointer text-center',
                accessor: 'nomePeriodo',
                width: 90,
            },
            {
                Header: 'Vigência',
                className: 'pointer text-center',
                Cell: row => row.original.estender ?
                    "estender" : "próx. edição",
                width: 90,
            },
            {
                Header: 'Preço',
                className: 'pointer text-center',
                accessor: 'preco',
                Cell: row => row.original.preco ?
                    `R$ ${(parseFloat(row.original.preco, 10) * row.original.qtde).toFixed(2).toString().replace('.', ',')}` : '',
                width: 90,
            },
            {
                Header: 'Desconto',
                className: 'pointer text-center',
                Cell: row => row.original.desconto.percentual ?
                    row.original.desconto.valor > 0 ? `${row.original.desconto.valor}%` : '-'
                    :
                    row.original.desconto.valor > 0 ? `R$ ${parseFloat(row.original.desconto.valor, 10).toFixed(2).toString().replace('.', ',')}` : '',
                width: 90,
            },
            {
                Header: 'Acréscimo',
                className: 'pointer text-center',
                Cell: row => row.original.acrescimo ?
                    `R$ ${parseFloat(row.original.acrescimo, 10).toFixed(2).toString().replace('.', ',')}` : '-',
                width: 90,
            },
            {
                Header: 'Valor Item',
                className: 'pointer text-center',
                Cell: row => {
                    return row.original.valorItem >= 0 ?
                        `R$ ${(parseFloat(row.original.valorItem, 10) * row.original.qtde).toFixed(2).toString().replace('.', ',')}` : '-'
                },
                width: 90,
            },
            {
                Header: '',
                className: 'pointer text-center',
                accessor: 'idProduto',
                Cell: row => parseInt(row.value, 10) === 10 || parseInt(row.value, 10) === 11 ? (<button className="btn btn-sm btn-outline-info" onClick={() => this.props.toggle(row.index)}>Beneficiários</button>) : '',
                width: 110
            },
            {
                Header: '',
                className: 'pointer text-center text-danger',
                Cell: row => (<div onClick={() => this.props.excluirItem(row.index)}><i className="far fa-trash-alt"></i></div>),
                width: 40,
            },
        ]
    }

    productBadgeType(status) {
        switch (status) {
            case "bs":
                return "primary";
            case "tc":
                return "danger";
            case "rd":
                return "warning";
            default:
                return "info";
        }
    }



    render() {
        return (
            <div className="row table-clients">
                <div className="col-12">
                    <div className="card">
                        <div className="card-body p-0">
                            <ReactTable
                                data={this.props.pedido}
                                columns={this.columns}
                                defaultPageSize={5}
                                manual
                                loading={this.state.loading}
                                className="-striped -highlight"
                                headerClassName="ebs-table-header"
                                previousText='Anterior'
                                nextText='Próximo'
                                loadingText='Carregando...'
                                noDataText='Nenhum item adicionado ao pedido.'
                                pageText='Página'
                                ofText='de'
                                rowsText='linhas'
                                getTrProps={(state, rowInfo, column, instance) => {
                                    return {
                                        onClick: (e, handleOriginal) => {
                                            // console.log("rowInfo", rowInfo)
                                        }
                                    }
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default TableOrder;